import BarPieChart from "./BarPieChart";
import './BarPieChart.scss';

export default BarPieChart;